export const LOCAL_STORAGE_PREFIX = "tracktor.";

const LOCAL_STORAGE_KEY = {
  dealsPlanningGroupBy: `${LOCAL_STORAGE_PREFIX}dealsPlanningGroupBy`,
  dealsPlanningViewMode: `${LOCAL_STORAGE_PREFIX}dealsPlanningViewMode`,
  dealsView: `${LOCAL_STORAGE_PREFIX}dealsView`,
  filter: `${LOCAL_STORAGE_PREFIX}filter`,
  isDarkTheme: `${LOCAL_STORAGE_PREFIX}isDarkTheme`,
  onboardingFeatureRequests: `${LOCAL_STORAGE_PREFIX}onboardingFeatureRequests`,
  sorenAnnouncementSeen: `${LOCAL_STORAGE_PREFIX}sorenAnnouncementSeen`,
  user: `${LOCAL_STORAGE_PREFIX}user`,
};

export default LOCAL_STORAGE_KEY;
